import React from 'react'

import Base from '../_Base'

const CircleCheckmarkFilled = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props} fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.7929 8.29289L17.2071 9.70711L10.5 16.4142L6.79289 12.7071L8.20711 11.2929L10.5 13.5858L15.7929 8.29289Z" fill="white"/>
  </Base>
)

export default CircleCheckmarkFilled

